import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { WebsitePageSet } from 'src/shared/types/website-page-interface'

export const getLocalesCountByPageSets = (pageSets: WebsitePageSet[]) => {
  return pageSets.reduce(
    (acc, pageSet) => {
      pageSet.locales.forEach(({ locale }) => {
        acc[locale] = (acc[locale] || 0) + 1
      })
      return acc
    },
    {} as Record<PageLocaleEnum, number>,
  )
}
